import getLocaleFromUrl from './get-locale-from-url';
import defineLocale from './define-locale';
import getURLWithoutLocale from './get-url-without-locale';

export default {
  getLocaleFromUrl,
  defineLocale,
  getURLWithoutLocale,
};
